class Enums {
    static WarehouseOrderStatus = [
        { value: 0, name: '正常' },
        { value: -1, name: '异常' },
        { value: 2, name: '驳回' },
        { value: 3, name: '待补充' }
    ];
    static WarehouseOrderDisplayStatus = [
        { value: 0, name: '正常(ปกติ)' },
        { value: -1, name: '异常(ความผิดปกติ)' },
        { value: 2, name: '驳回(ยกเลิก)' },
        { value: 3, name: '待补充(เพื่อเติมเต็ม)' }
    ];
    static HandleType = [
        { value: 1, name: '退货' },
        { value: 2, name: '拒收' },
    ];

    static StatisticalType = [
        { value: 1, name: '汇总' },
        { value: 2, name: '每日' },
    ];
    static ReturnOrderSource = [
        { value: 0, name: '本土订单' },
        { value: 1, name: '海外仓订单' },
        { value: 2, name: '囤货订单' },
        { value: 3, name: '海外退件订单' }
    ];
    static ReturnOrderStatus = [
        { value: 0, name: '退件存储中' },
        { value: 1, name: '待仓库发货' },
        { value: 2, name: '待仓库销毁' },
        { value: 3, name: '已发货' },
        { value: 4, name: '已销毁' },
    ];
    static HandleStatus = [
        { value: 0, name: '待处理' },
        { value: 1, name: '已退货' },
        { value: 2, name: '已拒收' },
        { value: 3, name: '已撤销' },
        {value:4,name:'处理失败'}
    ];
    static WarehouseOrderPackageStatus = [
        { value: 0, name: '未收货' },
        { value: 1, name: '已收货' },
        { value: 2, name: '已打包' },
        { value: 3, name: '已称重' },
        { value: 6, name: '待送仓' },
        { value: 4, name: '已出仓' },
        { value: 5, name: '已撤销' },
        { value: 7, name: '待补充运费'},
        { value: 8, name: '取消打包' },
    ];
    static ProductOrderStatus = [
       // { value: 1, name: '待支付' },
        { value: 2, name: '待发货' },
        { value: 3, name: '已发货' },
        { value: 4, name: '已完成' },
        { value: 5, name: '取消中' },
        { value: 6, name: '已取消' },
        { value: 7, name: '退款或退货' },
        { value: 12, name: '待处理' },
        //{ value: 8, name: '确定签收' },
        //{ value: 9, name: '退款成功' },
        //{ value: 10, name: '退款失败' },
        //{ value: 20, name: '无售后订单' },
        //{ value: 11, name: '待发货' },
    ];
    static ShipmentReceiveStatus = [
        { value: 1, name: '签收', color:'#02ba5a' },
        { value: 2, name: '拒收', color:'#ff0000' },
        { value: 0, name: '未签收', color: '' },
        { value: 3, name: '已退货', color: '#ff0000' },
    ];
    static completeStatus = [
        { value: 0, name: '未完成' },
        { value: 1, name: '已完成' }
    ];
    static WhetherArriveWarehouseStatus = [
        { value: true, name: '是' },
        { value: false, name: '否' },
    ];
    static WhetherStatus = [
        { value: true, name: '是' },
        { value: false, name: '否' },
    ];
    static WhetherHandle = [
        { value: true, name: '是' },
        { value: false, name: '否' },
    ];
    static WhetherStringStatus = [
        { value: "true", name: '是' },
        { value: "false", name: '否' },
    ];
    static IsEffectiveStatus = [
        { value: true, name: '是' },
        { value: false, name: '否' },
    ];
    static IsCheckStatus = [
        { value: true, name: '审核通过' },
        { value: false, name: '审核未通过' },
    ];
    static IsSend = [
        { value: true, name: '是' },
        { value: false, name: '否' },
    ];
    static WhetherHandleStatus = [
        { value: true, name: '是' },
        { value: false, name: '否' },
    ];
    static WhetherPayStatus = [
        { value: true, name: '是' },
        { value: false, name: '否' },
    ];
    static UserType = [
        { value: 0, name: '普通用户' },
        { value: 1, name: '业务员' },
    ];


    static PaymentChannelType = [
        { value: 0, name: '支付宝', logo:'../../../images/alipaylogo.png' },
    ];

    static UserAmountChannel = [
        { value: 0, name: '支付宝充值' },
        { value: 1, name: '平台退款' },
        { value: 2, name: '平台消费' },
        { value: 3, name: '退货消费' },
        { value: 4, name: '运费消费' },
        { value: 5, name: '运费退款' },
        { value: 6, name: '打包消费' },
        { value: 7, name: '打包退款' },
        { value: 8, name: '退货返回' },
        { value: 9, name: '头程费消费' },
        { value: 10, name: '上架费消费' },
        { value: 11, name: '仓储费消费' },
        { value: 12, name: '退件订单销毁消费' },
        { value: 13, name: '系统充值' },
        { value: 14, name: 'Shopee退回件运费消费' },
        { value: 15, name: '公共库存消费' },
        { value: 16, name: '公共库存退费' },
    ];

    static ImplementType = [
        { value: 0, name: '待处理' },
        { value: 1, name: '成功' },
        { value: 2, name: '失败' },
    ];
  
    static importTypeStatus = [
        { value: 0, name: '签收' },
        { value: 1, name: '拒签' },
    ];

    static ShopStatus = [
        { value: 0, name: '冻结' },
        { value: 1, name: '正常' },
        { value: 2, name: '已封禁' }
    ];

    static WarehouseOrderType = [
        { value: 0, name: '跨境' },
        { value: 1, name: '本土' },
        { value: 2, name: '海外' },
      /*  {value:3,name:'海外退货订单'}*/
    ];
    //本土
    static SiteSType = [
        //{ value: 2, name: '马来' },
        { value: 4, name: '泰国' },
/*        { value: 7, name: '越南' },*/
/*        { value: 5, name: '菲律宾' },*/
    ];
    static OverseasSiteType = [
/*        { value: 2, name: '马来' },*/
        { value: 4, name: '泰国' },
/*        { value: 7, name: '越南' },*/
    ];
    static DeductionType = [
        { value: 0, name: '未扣费' },
        { value: 1, name: '已扣费' },
    ];
    //跨境
    static ShopSiteType = [
        { value: 1, name: '台湾' },
        { value: 2, name: '马来' },
        { value: 3, name: '印尼' },
        { value: 4, name: '泰国' },
        { value: 5, name: '菲律宾' },
        { value: 6, name: '新加坡' },
        { value: 7, name: '越南' },
        { value: 8, name: '巴西' },
        { value: 9, name: '墨西哥' },
        { value: 10, name: '智利' },
        { value: 11, name: '哥伦比亚' },
        { value: 12, name: '波兰' },
        { value: 13, name: '西班牙' },
        { value: 14, name: '法国' }
    ];

    //平台类型
    static PlatformType = [
   //     { value: 0, name: 'Shopee' },
   //     { value: 1, name: 'Lazada' },
        { value: 2, name: 'TikTok' }
    ];

    static CargoCategoryType = [
        { value: 0, name: '普货' },
        { value: 1, name: '特货' },
        { value: 2, name: '敏感货' },
    ];
    static BillingType = [
        { value: 0, name: '半抛' },
        { value: 1, name: '全抛' },
    ];
    static ProductType = [
        { value: 0, name: '产品' },
        { value: 1, name: '耗材' },
    ];
    static ProductStatus = [
        { value: 0, name: '待国内接收' },
        { value: 1, name: '待海外仓接收' },
        { value: 2, name: '到达仓库' },
        { value: 3, name: '已上架' },
        { value: 4, name: '异常' },
        { value: 5, name: '已取消' },
        { value: 6, name: '已申请退货' },
        { value: 7, name: '已退货' },
    ];

    static ProductInStockType = [
        { value: 0, name: '备货入库' },
        { value: 1, name: '订单撤回入库' },
        { value: 2, name: '修改订单' },
        { value: 3, name: '退件入库' },
        { value: 4, name: '仓管添加' },
    ];
    static WhetherLocal = [
        { value: true, name: '是' },
        { value: false, name: '否' },
    ];
    static WhetherAbroadStatus = [
        { value: true, name: '是' },
        { value: false, name: '否' },
    ];
    static LogisticsChannelType = [
    ];

    static ProductOutStockType = [
        { value: 0, name: '创建订单' },
        { value: 1, name: '修改订单' },
    ];

    static ProductStockType = [
        { value: 0, name: '出库' },
        { value: 1, name: '入库' },
    ];
    static StockStatus = [
        { value: 0, name: '可用' },
        { value: 1, name: '不可用' },
        { value: 2, name: '禁用' }
    ];
    static UserConfigOrderType = [
        { value: 0, name: '跨境' },
        { value: 1, name: '本土' },
        { value: 2, name: '海外' },
        { value: 4, name: '囤货' }
    ];

    static OrderOperateType = [
        { value: 0, name: '标记急单' },
        { value: 1, name: '取消急单' },
        { value: 2, name: '标记异常' },
        { value: 3, name: '标记正常' }
    ];
    static getEnum(obj: any, isAll: boolean) {
        var data = [];
        if (isAll) {
            data.push({value:null,name:'全部'});
        }
        for (var value of obj) {
            data.push({ value: value.value,name:value.name });
        }
        return data;
    }
}
export default Enums;